import { VisitAndAppointmentView } from '@dreryk/egabinet-visit-frontend-api';

import { protectFeature } from '~libs.shared.system';

import { RefetchAppointments } from '../../../appointments.types';

import { CancelAppointmentButton } from './CancelAppointmentButton';
import { ContinueVisitButton } from './ContinueVisitButton';
import { ShowVisitButton } from './ShowVisitButton';
import { StartVisitButton } from './StartVisitButton';

export type OptionsCellProps = {
   readonly isFutureVisit: boolean;
   readonly visitAndAppointmentView: VisitAndAppointmentView;
   readonly refetchAppointments: RefetchAppointments;
   readonly ownedByCurrentUser: boolean;
};

export const OptionsCell = (props: OptionsCellProps): JSX.Element | null => {
   const { visitAndAppointmentView, refetchAppointments, isFutureVisit, ownedByCurrentUser } = props;

   switch (visitAndAppointmentView.status) {
      case 'REGISTERED':
         return protectFeature(
            'searchingVisitOperations',
            <StartVisitButton
               appointmentId={visitAndAppointmentView.appointmentId}
               disabled={isFutureVisit || !ownedByCurrentUser}
               patientId={visitAndAppointmentView.patientId}
               onVisitAlreadyStartedFault={refetchAppointments}
               onAppointmentAlreadyCancelledFault={refetchAppointments}
            />,
            protectFeature(
               'creatingAppointments',
               <CancelAppointmentButton
                  appointmentId={visitAndAppointmentView.appointmentId}
                  cancellable={visitAndAppointmentView.cancellable}
                  refetchAppointments={refetchAppointments}
               />,
               null
            )
         );
      case 'IN_PROGRESS':
      case 'FINISHED_NOT_APPROVED':
         return protectFeature(
            'searchingVisitOperations',
            <ContinueVisitButton
               appointmentId={visitAndAppointmentView.appointmentId}
               visitId={visitAndAppointmentView.visitId!}
               patientId={visitAndAppointmentView.patientId}
               disabled={!ownedByCurrentUser}
            />,
            null
         );
      case 'FINISHED_APPROVED':
         return protectFeature(
            'searchingMedicalData',
            <ShowVisitButton visitId={visitAndAppointmentView.visitId} patientId={visitAndAppointmentView.patientId} />,
            null
         );
      case 'CANCELLED':
      default:
         return null;
   }
};
